module.exports = __webpack_public_path__ + "static/pp-e5649249c921a2dec140b5d29f26ff0f.jpg";